<template>
  <div class="content-intro">
      <div class="shell">
          <div class="intro">
            <div class="intro__figure-top">
                <img :src="require(`@/assets/images/intro-figure-1.svg`)" alt="">
            </div>

            <div>
                <h2 class="h1">
                    <strong>Accesso Negato!</strong>
                </h2>
            </div>

            <div class="intro__figure-bottom">
                <img :src="require(`@/assets/images/intro-figure-2.svg`)" alt="">
            </div>
        </div>

      </div>
  </div>
</template>

<script>
import {inject} from 'vue';
import {useStore} from "vuex";

export default {
    name: 'Denied',

    components: {
    },
}
</script>
